import { getLocalizationInfo } from 'project.config';
import useLocale from './useLocale';

const useI18n = () => {
  const { ctLocale: locale } = useLocale();

  const config = getLocalizationInfo(locale);

  const country = config.countryCode;

  const currency = config.currency;

  const currencySymbol = config.currencyCode;

  return { country, currency, currencySymbol };
};

export default useI18n;
